module.exports = __webpack_public_path__ + "static/media/module4.87ee06c3.png";